import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useStore } from "../../app/stores/store";
import { Button, Header } from 'semantic-ui-react'
import { Formik, Form } from "formik";
import * as Yup from 'yup';
import { MySelectInput } from "../../app/common/form/MySelectInput";
import { SaldosReportesFormValues } from "../../app/models/SaldosReporte";
import '../Pagos/Operaciones_style.css'
import { Message } from 'semantic-ui-react'
import MyTextInput from "../../app/common/form/MyTextInput";
import StickyHeadTable from "./TablaReporteInscritos";
import XLSX from "xlsx";
import ReactExport from "react-export-excel";
import Swal from "sweetalert2";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { loadavg } from "os";
import { Link } from "react-router-dom";
import SubMenuOPReportes from "../Operaciones/MenuOperaciones";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Container from 'react-bootstrap/Container';
import Pagination from 'react-bootstrap/Pagination';
import axios from "axios";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

var numberPagina: number;

export default observer(function ReporteInscritos() {

    const SuccesModal = () => {
        Swal.fire({
            position: "center",
            icon: "success",
            title: "Datos exportados",
            text: 'Los datos del usuario se han exportado correctamente',
            showConfirmButton: false,
            timer: 3500,
        });
    };

    const { ReporteInscritosStore } = useStore();
    const { busquedaInforme, descargaInforme } = ReporteInscritosStore

    const [currentPage, setCurrentPage] = useState(1);
    const [keyword, setKeyword] = useState('0');
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());    

    useEffect(() => {
        busquedaInforme(keyword, currentYear, currentPage, 12)
    }, [currentPage, busquedaInforme])


    const validationSchema = Yup.object({
        busqueda: Yup.string().required('Obligatorio'),
    })

    function handleFormSubmit(valor: any) {        
        const newKeyword = valor['busqueda'] !== '' ? valor["busqueda"] : "0";           
        setKeyword(newKeyword);            
        
        busquedaInforme(keyword, currentYear, currentPage, 12)
    }

    const handlePageClick = (numberPagina: number, year: number, keyword: string) => {
        setCurrentPage(numberPagina); 
        setCurrentYear(year);
        setKeyword(keyword);
    }

    const handleDownload = () => {        
        descargaInforme(keyword, currentYear);
    }

    /** Pagination list */
    const neighbors = 2

    let items = [];
    for (let number = 1; number <= ReporteInscritosStore.totalPages; number++) {
        if (
            number === 1 ||
            number === ReporteInscritosStore.totalPages ||
            (number >= currentPage - neighbors && number <= currentPage + neighbors)
        ) {
            items.push(
                <Pagination.Item key={number} activeLabel={""} onClick={() => {
                    handlePageClick(number, currentYear, keyword);
                }} active={number === currentPage}>
                    {number}
                </Pagination.Item>,
            );
        } else if (
            (number === currentPage - neighbors - 1) ||
            (number === currentPage + neighbors + 1)
        ) {
            items.push(
                <Pagination.Item key={number} disabled>
                    ...
                </Pagination.Item>
            );
            // Saltar los números entre los puntos suspensivos
            if (number < currentPage) number = currentPage - neighbors - 1;
            else number = ReporteInscritosStore.totalPages - 1;
        }
    }

    if(ReporteInscritosStore.loadingInitial == true) return <><LoadingComponent content="Cargando datos..." /></>

    let current_year = new Date().getFullYear();
    let start_year = 2022;
    let year_range = [];
    for (let i = current_year; i >= start_year; i--)
        year_range.push(i);

    let options_year = year_range.map(x => 
        <option key={x} value={x}>{x}</option>
    )
    
    return (

        <>

            <SubMenuOPReportes />

            <div>
                <div className="header_operaciones">
                    <h1>Reporte de Inscritos</h1>
                </div>
                <br></br>
                <br></br>
                <br></br>
                <h2>Ingrese su criterio de busqueda.</h2>
                <h4>(Codigo de curso, Nombre, CUI, NIT, etc)</h4>
                <div className="buscar_operaciones">
                    <div className="d-flex justify-content-between">
                        <Formik 
                            enableReinitialize
                            initialValues={{ busqueda: "" }}
                            onSubmit={values => handleFormSubmit(values)}>
                            {({ handleSubmit, isValid, isSubmitting, dirty }) => (
                                <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                                    <div className='form_buscar_operaciones'>
                                        <div>
                                            <MyTextInput id="busqueda" name='busqueda' placeholder='' />
                                        </div>
                                        <div>
                                            <select name="year" id="year_list" onChange={(e) =>     setCurrentYear(parseInt(e.target.value)) }>
                                                <option value="">-- Seleccione --</option>
                                                {options_year}
                                            </select>
                                        </div>
                                        <div className="boton_buscar_operaciones">
                                            <Button
                                                type='submit'
                                                content='Buscar'
                                                style={{ backgroundColor: "#15b3e8", color: "white" }}
                                            />
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>

                        <button onClick={handleDownload} style={{ backgroundColor: "#15b3e8", color: "#ffffff", paddingRight: "10px", paddingLeft: "10px", border: "0" }}>Exportar</button>

                        {/* <ExcelFile element={

                            <Button
                                type='submit'
                                content='Exportar'
                                onClick={SuccesModal}
                                style={{ backgroundColor: "#15b3e8", color: "white" }}
                            />}>

                            <ExcelSheet data={ReporteInscritosStore.ReporteInscritosByCodigo} name="data">
                                <ExcelColumn label="No." value="id" />
                                <ExcelColumn label="DPI" value="dpi" />
                                <ExcelColumn label="Nombres" value="nombres" />
                                <ExcelColumn label="Apellidos" value="apellidos" />
                                <ExcelColumn label="Fecha Nacimiento" value="fechaNacimiento" />
                                <ExcelColumn label="Identidad Cultural" value="identidadCultural" />
                                <ExcelColumn label="Comunidad Linguistica" value="comunidadLinguistica" />
                                <ExcelColumn label="NIT" value="nit" />
                                <ExcelColumn label="Departamento" value="reDepartamento" />
                                <ExcelColumn label="Municipio" value="reMunicipio" />
                                <ExcelColumn label="Celular" value="celular" />
                                <ExcelColumn label="Grado Academico" value="proGradoAcademico" />
                                <ExcelColumn label="Actividad Economica" value="labActividadEconomica" />
                                <ExcelColumn label="Entidad" value="labEntidad" />
                                <ExcelColumn label="Dependencia" value="labDependencia" />
                                <ExcelColumn label="PuestoFuncional" value="labPuestoFuncional" />
                                <ExcelColumn label="Renglon" value="labRenglon" />
                                <ExcelColumn label="Código Cuenta" value="codigoCuenta" />
                                <ExcelColumn label="Preinscripcion" value="preInscripcion" />
                                <ExcelColumn label="Aprobado Por" value="aprobadoPor" />
                                <ExcelColumn label="Nombre Del Curso" value="nombre" />
                            </ExcelSheet>
                        </ExcelFile> */}
                    </div>
                    <br></br>
                    <br></br>
                    <div>
                        <StickyHeadTable />
                    </div>                    
                    <div className="mt-5">
                        <Container className='pagination-convenios-area'>
                            <Pagination>{items}</Pagination>
                        </Container>
                    </div>
                </div>
            </div>
        </>
    )
})